import { ActivatedRoute, Router } from '@angular/router';
import { AppConstant } from '@constants/app.constant';
import { TranslateService } from '@ngx-translate/core';
import { ModalDirective, TabsetComponent } from 'ngx-bootstrap';
import { Component, ViewChild, Input, EventEmitter, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { PageResponse } from '@app/models/page-response';
import { OnepageProduct, OnepageProductFormSearchingCriteria } from '@app/models/onepage-product';
import { ProductService } from '@app/services/product.service';
import { DeploymentProductInfo } from '@app/models/deployment-product-info';
import { Deployment } from '@app/models/deployment';


@Component({
    selector: 'product-selector',
    templateUrl: './product-selector.component.html',
    styleUrls: ['./product-selector.component.scss']
})

export class ProductSelector {
    @ViewChild('modal', { static: false }) modal: ModalDirective;
    @Output() onSave: EventEmitter<OnepageProduct> = new EventEmitter();

    records: OnepageProduct[];
    selectedRecords: OnepageProduct;
    originalDeploymentProductInfo: OnepageProduct;

    private searchTermStream = new Subject<string>();
    loading: boolean = false;
    isFromOpen: boolean;

    globalCriteria: OnepageProductFormSearchingCriteria;
    page: number = 1;
    size: number = 10;
    totalItems: number = 0;
    sortField: string;
    sortDirection: 'asc' | 'desc';

    pagingInfo: {
        start: number;
        end: number;
        total: number;
    }

    constructor(private router: Router,
        private route: ActivatedRoute,
        public appConstant: AppConstant,
        private onepageProductService: ProductService,
        private translate: TranslateService,) {
    }

    ngOnInit(): void {

        this.globalCriteria = new OnepageProductFormSearchingCriteria();
        this.loading = true;
        this.pagingInfo = {
            start: 0,
            end: 0,
            total: 0
        }

        this.page = 0;
        this.size = 10;
        this.totalItems = 0;
        this.sortField = 'productName';
        this.sortDirection = 'asc';
        if (this.isFromOpen) {
            this.doSearch(this.globalCriteria, this.page, this.sortField, this.size, this.sortDirection);
        }

        this.searchTermStream
            .pipe(debounceTime(500), distinctUntilChanged())
            .subscribe(() => this.doSearch(this.globalCriteria, this.page, this.sortField, this.size, this.sortDirection));


    }

    sort(field: string): void {
        this.sortField = field;

        if (this.sortField === field) {
            this.sortDirection === 'asc' ? this.sortDirection = 'desc' : this.sortDirection = 'asc';
        } else {
            this.sortField = field;
            this.sortDirection === 'asc';
        }

        this.doSearch(this.globalCriteria, this.page, field, this.size, this.sortDirection);
    }

    pageChange(changedPage: number): void {
        if (this.page != changedPage) {
            this.doSearch(this.globalCriteria, changedPage, this.sortField, this.size, this.sortDirection);
        }
    };

    private doSearch(criteria: OnepageProductFormSearchingCriteria, page: number, sortField: string, size: number, sortDirection: string) {
        this.records = [];
        this.loading = true;
        this.onepageProductService.globalSearch('', criteria, page - 1, size, sortField, sortDirection)
            .subscribe((res: PageResponse<OnepageProduct>) => {
                this.loading = false;
                this.page = res.number + 1;
                this.totalItems = res.totalElements;
                this.records = res.content;
                this.pagingInfo.start = (this.page - 1) * this.size + 1;
                this.pagingInfo.end = this.page * this.size;
                this.pagingInfo.total = this.totalItems;
                if (this.pagingInfo.end > this.pagingInfo.total) {
                    this.pagingInfo.end = this.pagingInfo.total;
                }

                this.setupSelectedRecords();
            });
    }

    setupSelectedRecords() {
        if (this.selectedRecords) {
                let record = this.records.find(x => this.selectedRecords.productCode == x.productCode);
                if (record) {
                    record._selected = true;
                    this.selectedRecords = record;
                }
            }
    }

    search(term: string) {
        this.searchTermStream.next(term);
    }


    ngOnDestroy(): void {
    }

    select(record: OnepageProduct) {
        if(this.selectedRecords){
            this.selectedRecords._selected = false;
        }

        this.selectedRecords = record;
        if(record._selected){
            record._selected = false;
        }else{
            record._selected = true;
        }
    }


    public open(originalRecords: OnepageProduct): void {
        this.originalDeploymentProductInfo = originalRecords;
        this.selectedRecords =originalRecords;
        this.isFromOpen = true;
        this.ngOnInit();
        this.modal.show();
    }

    public close(): void {
        this.isFromOpen = false;
        this.modal.hide();
    }

    public save(): void {
        this.isFromOpen = false;
        this.modal.hide();
        this.onSave.emit(this.selectedRecords);
    }
}